import * as React from 'react';
import classnames from 'classnames';

export default function StepIndex({index, passed}) {
  const cssClasses = classnames({
    'pathway-step-index': true,
    'pathway-step-index--completed': !!passed,
  });

  return (
    <div className={cssClasses}>
      <div className='pathway-step-index__content'>
        {index}
      </div>
    </div>
  );
}

export function StepIcon({icon, passed}) {
  if (!icon) {
    return null;
  }

  const cssClasses = classnames({
    'pathway-step-index': true,
    'pathway-step-index--completed': !!passed,
    ['pathway-step-index--icon-' + icon]: icon,
  });

  return (
    <div className={cssClasses}>
      <div className='pathway-step-index__content'>
      </div>
    </div>
  );
}
